/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { Typography } from '../../components/Typography';
import { Card } from '../../components/Card';
import { Button } from '../../components/Button';
import { IGetMemberResponse } from '../members/members.slice';
import { IUser } from '../auth/auth.slice';
import { UserForm } from '../../components/form/user-form/user-form';
import { validateUser } from '../../models/validate-user';
import type { User } from '../../models/user';

const useStyles = makeStyles((theme) => ({
  cardWithoutTable: {
    paddingLeft: 24,
    paddingRight: 24,
  },
  cardTitle: {
    fontSize: '1.2rem',
    height: 64,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
}));

interface IMemberInfoCard {
  allCustomer: boolean;
  handleEditCustomer: any;
  subadminList: IGetMemberResponse;
  user: User;
  updateUser: (user: User) => void;
}

export const MemberInfoCard: React.FunctionComponent<IMemberInfoCard> = ({
  allCustomer,
  subadminList,
  user,
  handleEditCustomer,
  updateUser,
}) => {
  const intl = useIntl();
  const { fieldErrors, hasErrors } = validateUser(user, [
    'password',
    'parentId',
  ]);
  const { cardWithoutTable, cardTitle } = useStyles();

  const onClickActionButton = () => {
    if (!hasErrors) {
      const customerData = {
        id: user?._id,
        name: user.profile.name,
        contactNumber: user.profile.contactNumber,
        email: user.email,
        ...(allCustomer && { parentId: user.parentId }),
      };
      handleEditCustomer(customerData);
    }
  };

  return (
    <Card customStyles={cardWithoutTable}>
      <div>
        <Typography variant="h6" className={cardTitle}>
          <FormattedMessage id="details" />
        </Typography>
        <UserForm
          fields={{
            name: {
              error: fieldErrors.name,
              required: true,
            },
            contactNumber: {
              error: fieldErrors.contactNumber,
              required: true,
            },
            email: {
              error: fieldErrors.email,
              required: true,
            },
            parentId: {
              error: allCustomer ? fieldErrors.parentId : false,
              required: allCustomer,
            },
            ...(allCustomer && {
              parentId: {
                error: fieldErrors.parentId,
                required: true,
                //@ts-ignore
                options: subadminList.data,
              },
            }),
            role: {
              error: fieldErrors.role,
              required: true,
              options: [
                {
                  label: intl.formatMessage({
                    id: 'customer',
                  }),
                  value: 'customer',
                },
                {
                  label: intl.formatMessage({
                    id: 'subadmin',
                  }),
                  value: 'subadmin',
                },
              ],
              disabled: true,
            },
            status: {
              error: fieldErrors.status,
              required: true,
              disabled: true,
            },
          }}
          updateUser={updateUser}
          user={user}
        />
      </div>
      <div style={{ float: 'right' }}>
        <Button
          id="group-management"
          label={intl.formatMessage({
            id: 'update',
          })}
          variant="contained"
          onClick={onClickActionButton}
          disabled={hasErrors}
        />
      </div>
    </Card>
  );
};
